import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import Input from '../../Input/Input';
import AddressField from '../../Custom/AddressField';
import CommentField from '../../CommentField/CommentField';

import '../../SampleInfo/SampleInfo.scss';

function PressureSensorDetailsTab(props, context) {
  const {
    handleSubmit,
    pristine,
    submitting,
    user,
    onUninstall,
    sensorData,
    selectedFeature,
    onEdit,
    onCopy,
    getAddressByLatLong,
    notify,
  } = props;

  const [showConfirm, setShowConfirm] = useState(false);

  const labelsClass = 'col-xs-4 control-label';
  const fieldsClass = 'col-xs-8 control-input';
  const divStyle = { float: 'left', width: '100%' };

  return (
    <div>
      <form className="form-horizontal sticky-actions" onSubmit={handleSubmit}>
        <CommentField
          fieldName="Comment"
          featureID={selectedFeature}
          placeholder={context.t('sensor_comment')}
          onEdit={onEdit}
          onCopy={onCopy}
          disabled={!user.editMode}
        />

        <div style={{ display: 'flex' }}>
          <div style={divStyle}>
            <AddressField
              className="form-group"
              user={user}
              fieldName="Address"
              onGetAddress={getAddressByLatLong}
            />
            <div className="form-group">
              <label className={labelsClass}>
                {context.t('type')}:
              </label>
              <div className={fieldsClass}>
                <Field
                  name="type_meaning"
                  component={Input}
                  type="text"
                  disabled
                  className="form-control"
                />
              </div>
            </div>
            <div className="form-group">
              <label className={labelsClass}>
                {context.t('manufacturer')}:
              </label>
              <div className={fieldsClass}>
                <Field
                  name="manufacture_name"
                  component={Input}
                  type="text"
                  disabled
                  className="form-control"
                />
              </div>
            </div>
            <div className="form-group">
              <label className={labelsClass}>
                {context.t('sensor_install_date')}:
              </label>
              <div className={fieldsClass}>
                <Field
                  name="sensor_installation_date"
                  component={Input}
                  type="date"
                  className="form-control"
                  disabled={!user.editMode}
                />
              </div>
            </div>
            <div className="form-group">
              <label className={labelsClass}>
                {context.t('logger_install_date')}:
              </label>
              <div className={fieldsClass}>
                <Field
                  name="logger_installation_date"
                  component={Input}
                  type="date"
                  className="form-control"
                  disabled={!user.editMode}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="form-actions text-right">
          <button
            className="btn btn-success btn-submit"
            disabled={pristine || submitting}
            type="submit"
          >
            {context.t('save')}
          </button>
          {user.editMode && onUninstall && sensorData && (
            <>
              {!showConfirm ? (
                <button
                  className="btn btn-danger"
                  type="button"
                  onClick={() => setShowConfirm(true)}
                  style={{ marginLeft: '10px' }}
                >
                  {context.t('uninstall')}
                </button>
              ) : (
                <span style={{ marginLeft: '10px' }}>
                  <span style={{ marginRight: '10px' }}>{context.t('are_you_sure')}</span>
                  <button
                    className="btn btn-danger"
                    type="button"
                    onClick={() => {
                      const sensorId = sensorData.id;
                      setShowConfirm(false);
                      onUninstall(sensorId, (result) => {
                        if (!notify || !result) return;
                        const message = result.message || context.t(result.messageKey);
                        notify(message, result.level);
                      });
                    }}
                  >
                    {context.t('yes')}
                  </button>
                  <button
                    className="btn btn-default"
                    type="button"
                    onClick={() => setShowConfirm(false)}
                    style={{ marginLeft: '5px' }}
                  >
                    {context.t('cancel')}
                  </button>
                </span>
              )}
            </>
          )}
        </div>
      </form>
    </div>
  );
}

PressureSensorDetailsTab.contextTypes = {
  t: PropTypes.func.isRequired,
};

const pressureSensorDetailsTabForm = reduxForm({
  form: 'pressureSensorDetails',
  enableReinitialize: true,
})(PressureSensorDetailsTab);

export default pressureSensorDetailsTabForm;
